import { useState } from 'react';

export const useComponentInternalId = () => {
  // Internal Component Id used to identify a component instance
  const [internalId] = useState(Math.random().toString());
  return internalId;
};
